import React, { useEffect, useState } from 'react';
import Axios from '../../../axios/axios';
import { getCompleteData, getItems, getYears } from '../../../actions/HomeAction';

function EngineeringAdvancedSearch({ filters, setFilters, categories, subcategories: passedSubcategories }) {

  const [subcategories, setSubcategories] = useState([]);

  // Only advanced search fields — these will be reset by Clear button
  const initialAdvancedFilters = {
    year: '',
    regionId: '',
    material: '',
    compatibleModels: '',
    features: '',
    certifications: '',
    productType: '',
  };

  // (Not used anymore, but kept if needed later)
  const initialFilters = {
    year: '',
    regionId: '',
    material: '',
    compatibleModels: '',
    features: '',
    certifications: '',
    brandId: '',
    modelId: '',
    categoryId: '',
    productType: '',
  };

  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  useEffect(() => {
    getItems(setRegions);
    setYears(getYears());
    getCompleteData(setBrands, null, setModels); // removed stateCategories
  }, []);

  useEffect(() => {
    if (!filters.categoryId) {
      setSubcategories([]);
      return;
    }

    // If ProductList already passed subcategories, use them
    if (passedSubcategories && passedSubcategories.length > 0) {
      setSubcategories(passedSubcategories);
      return;
    }

    // Otherwise get subcategories from categories prop
    const selectedCat = categories?.find(
      (cat) => cat._id === filters.categoryId
    );

    setSubcategories(selectedCat?.subcategories || []);
  }, [filters.categoryId, passedSubcategories, categories]);

  // Sends only the changed field to the parent component
  const handleChange = (e) => {
    setFilters({ [e.target.name]: e.target.value });
  };

  // Clears ONLY advanced search fields
  const clearFilters = () => {
    setFilters(initialAdvancedFilters); // sends only advanced filters
  };

  return (
    <div className="container py-4">
      <h4 className="mb-3">Engineering Advanced Search</h4>

      {/* Clear Filters Button */}
      <button
        type="button"
        className="btn btn-sm btn-secondary mb-3"
        onClick={clearFilters}
      >
        Clear Filters
      </button>

      {/* Subcategory dropdown (visible only if available) */}
      {subcategories.length > 0 && (
        <div className="advanced-filter-wrapper mb-2">
          <select
            name="subcategoryId"
            value={filters.subcategoryId || ""}
            className="form-control"
            onChange={handleChange}
          >
            <option value="">Select Subcategory</option>
            {subcategories.map((sub) => (
              <option key={sub._id} value={sub._id}>
                {sub.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="advanced-filter-wrapper mb-2">
        <select
          name="year"
          value={filters.year}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <select
          name="regionId"
          value={filters.regionId}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Region</option>
          {regions.map((r) => (
            <option key={r._id} value={r._id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <input
          name="material"
          value={filters.material}
          placeholder="Material"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <input
          name="compatibleModels"
          value={filters.compatibleModels}
          placeholder="Compatible Models"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <input
          name="features"
          value={filters.features}
          placeholder="Features"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <input
          name="certifications"
          value={filters.certifications}
          placeholder="Certifications"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      <div className="advanced-filter-wrapper mb-2">
        <input
          name="productType"
          value={filters.productType}
          placeholder="Product Type (e.g. Engineering, Auto-Spare)"
          className="form-control"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default EngineeringAdvancedSearch;
